import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
// import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { Request, Notification, Util, runtime, createIcon } from '../../common';
import { CircularProgress, Radio } from '@material-ui/core';
import { Cluster, Scrollbar } from '../Base';
import DataBase, { updateArray, getColumnField } from './Base';

import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { GoCellLink, Link } from '../Button';
import { LoadingSlim } from '../Backdrop';
import { TextBox } from '../TextBox';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));


// count={dataCount}
// rowsPerPage={pageSize}
// page={pageIndex-1}
// onChangePage={this.handleChangePage}
// onChangeRowsPerPage={this.handleChangeRowsPerPage}

function TablePagination({ numSelected, dataCount, pageCount, rowsPerPage, page, onChangePage, showPage }) {
  const classes = useStyles();

  return (
    <td colSpan="1000" className={classes.root}>
      <div className="d-flex d-row justify-content-between align-items-center my-2">
        <div className="d-flex d-row justify-content-start align-items-center">
          <p className="mb-0 c-text-s2 text-dark ml-2">{`共 ${dataCount} 项`}</p>
          {numSelected > 0 ? <p className="mb-0 ml-2 c-text-s2 text-dark2">已选 {numSelected} 项</p> : null}
        </div>
        {showPage !== false ? <div className="d-flex d-row justify-content-start align-items-center">
          <p className="mb-0 mr-2 c-text-s2 text-dark2">{`每页 ${rowsPerPage} 项`}</p>
          <Pagination className="d-flex" count={pageCount} page={page} onChange={onChangePage} showFirstButton showLastButton />
        </div> : null}

      </div>
    </td>
  );
}

const headerCellClassName = "m-bg-light c-lt";

class DataTableHead extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  byColumns() {
    const { columns, order, orderBy, go, headerDisablePadding, headerClassName } = this.props;
    return (
      columns.map((column, i) => {
        return (
          <TableCell
            className={`${headerCellClassName} ${headerClassName}`}
            key={i}
            align={column.align}
            width={column.width || "auto"}
            padding={headerDisablePadding ? 'none' : 'default'}
            style={{ whiteSpace: "nowrap" }}
          >
            {column.label}
            {/* {目前不支持排序} */}
            {/* <Tooltip
              title="排序"
              placement={column.numeric ? 'bottom-end' : 'bottom-start'}
              enterDelay={300}
            >
              <TableSortLabel
                active={orderBy === column.id}
                direction={order}
                onClick={this.createSortHandler(column.id)}
              >
                {column.label}
              </TableSortLabel>
            </Tooltip> */}
          </TableCell>
        );
      }, this)).concat(
        go ? <TableCell
          className={`${headerCellClassName} ${headerClassName}`}
          key={"header-go"}
          align={"center"}
          width={"50px"}
          padding={headerDisablePadding ? 'none' : 'default'}
          style={{ whiteSpace: "nowrap" }}
        >
        </TableCell>
          : null)
  }

  byHeaders() {
    const { headers, disablePadding } = this.props;
    return (
      headers.map((header, i) => {
        return (
          <TableCell
            className={headerCellClassName}
            key={i}
            align={header.align}
            width={header.width || "auto"}
            colSpan={header.colspan || header.colSpan || 1}
            padding={(header.disablePadding || disablePadding) ? 'none' : 'default'}
            style={{ whiteSpace: header.nowrap === false ? "normal" : "nowrap" }}
          >
            {header.component ? header.component() : header.label}
          </TableCell>
        );
      }, this))
  }

  render() {
    const { onSelectAllClick, numSelected, rowCount, checkbox, radio, headers, radioName } = this.props;
    return (
      <TableHead>
        <TableRow>
          {
            checkbox ?
              <TableCell padding="checkbox"
                className={headerCellClassName}
              >
                <Checkbox color="primary"
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={numSelected === rowCount}
                  onChange={onSelectAllClick}
                />
              </TableCell> : null
          }
          {
            radio ?
              <TableCell padding="checkbox"
                className={headerCellClassName}
              >
                <Radio name={radioName + "-header"} color="primary"
                  checked={numSelected > 0}
                  onClick={onSelectAllClick}
                />
              </TableCell> : null
          }
          {headers ? this.byHeaders() : this.byColumns()}
        </TableRow>
      </TableHead>
    );
  }
}


let DataTableToolbar = props => {
  const { numSelected, title } = props;
  if (!title) return null;
  return (
    <Toolbar className="table-header">
      <div className="title">
        <Typography variant="h6">{title}</Typography>
      </div>
    </Toolbar>
  );
};


export default class DataTable extends DataBase {
  handleRequestSort = (event, property) => {
    // const orderBy = property;
    // let order = 'desc';

    // if (this.state.orderBy === property && this.state.order === 'desc') {
    //   order = 'asc';
    // }
    // 目前不支持排序
    // const data =
    //   order === 'desc'
    //     ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
    //     : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    // this.setState({data, order, orderBy});
  };
  handleSelectAllClick = (event, checked) => {
    let { onAllRowSelected } = this.props;
    if (this.radio()) {
      this.setState({ selected: [] }, () => {
        if (onAllRowSelected) onAllRowSelected([]);
      });
      return;
    }

    let { rows, selected } = this.state;
    var my = this;
    if (checked) {
      rows.forEach((row) => {
        var key = my.getRowKey(row);
        if (!my.isSelected(key)) {
          selected = my.addOrRemove(selected, key);
        }
      });
    } else {
      rows.forEach((row) => {
        var key = my.getRowKey(row);
        if (my.isSelected(key)) {
          selected = my.addOrRemove(selected, key);
        }
      });
    }
    this.setState({ selected }, () => {
      if (onAllRowSelected) onAllRowSelected(selected);
    });
  };
  handleKeyDown = (event, key) => {
    if (keycode(event) === 'space') {
      this.handleRowClick(event, key);
    }
  };

  handleChangePage = (event, page) => {
    this.setState({ pageIndex: page }, () => {
      this.load();
    });
  };
  handleChangeRowsPerPage = event => {
    this.setState({ pageSize: event.target.value, pageIndex: 1 }, () => {
      this.load();
    });
  };

  reload(p) {
    p = p || {};
    let { type, item, position } = p;
    if (type === "update") {
      let { selected, rows } = this.state;
      this.updateArray(selected, item);
      this.updateArray(rows, item);
      this.setState({ selected, rows });
    } else if (type === "delete") {
      let { selected } = this.state;
      this.deleteArray(selected, item);
      this.setState({ selected }, () => {
        //刷新当前页
        this.load();
      });
    } else {
      //刷新当前页
      this.load();
    }
  }

  load(p) {
    p = p || {};
    let { action, data } = this.props;
    let { pageIndex } = this.state;
    let url = action;
    let arg = this.getParams();
    arg.pageIndex = pageIndex;
    arg.pageSize = this.getPageSize();

    let my = this;

    this.setState({
      loading: true
    }, () => {
      if (data) {
        let r = this.getData();
        my.success(r, p);
      } else {
        Request({
          url: url,
          data: arg,
          before: () => {
          },
          complete: () => {

          },
          success: (r) => {
            my.success(r, p);
          },
          error: (msg) => {
            Notification.error(msg);
          }
        });
      }
    });
  }

  getData() {
    let { data } = this.props;
    if (data) {
      let r = null;
      if (data.rows) {
        r = { rows: data.rows, pageIndex: 1, pageCount: 1, dataCount: data.rows.length, ...data };
      }
      else {
        r = { rows: data, pageIndex: 1, pageCount: 1, dataCount: data.length };
      }
      return r;
    }
    else {
      let { rows, pageIndex, pageCount, dataCount } = this.state;
      return { rows, pageIndex, pageCount, dataCount };
    }
  }

  getPageSize() {
    return this.state.pageSize || this.props.pageSize;
  }

  success(r, p) {
    if (this.isUnmounted()) return;

    if (this.props.dataReceived) {
      this.props.dataReceived(r);
    }

    if (this.props.page) {
      let pageIndex = r.pageIndex; //归位pageIndex
      let needLoad = false;
      if (pageIndex > r.pageCount && r.pageCount != 0) {
        //页码出错，校正页码后重新加载
        pageIndex = r.pageCount;
        needLoad = true;
      }


      let rows = r.rows || r.data;
      this.syncSelect(rows);
      this.setState({
        pageIndex,
        rows,
        loading: false,
        pageCount: r.pageCount,
        dataCount: r.dataCount
      }, () => {
        if (needLoad)
          this.load(p);
      });
    }
    else {
      //非翻页模式
      let rows = r.rows || r.data;
      this.syncSelect(rows);
      this.setState({
        rows,
        loading: false,
        dataCount: r.dataCount
      });
    }

  }

  syncSelect(rows) {//由于数据可能被修改，所以需要从最新的数据中同步下selected的数据
    if (!rows || rows.length == 0) return;
    let my = this;
    let selected = this.state.selected;
    for (let i = 0; i < selected.length; i++) {
      let current = selected[i];
      let row = Util.first(rows, (row) => my.getRowKey(row).value == current.value);
      if (row)
        selected[i] = my.getRowKey(row);
    }
    this.setState({ selected });
  }


  constructor(props, context) {
    super(props, context);

    let data = this.state;
    this.state = {
      order: 'asc',
      // orderBy: 'calories',
      rows: [],
      loading: true,
      pageIndex: 1,
      pageCount: 0,
      dataCount: 0,
      ...data
    };
  }

  componentWillMount() {
    super.componentWillMount();
  }

  getColumnLength() {
    let { columns } = this.props;
    var count = columns.length;
    if (this.checkbox() || this.radio()) count++;
    return count;
  }

  renderCell(item, index) {
    let { renderItem, repeater } = this.props;
    let { layout, gap } = repeater;
    gap = !Util.invalid(gap) ? gap : 2;
    return (
      <div key={index} className={`col-12 ${layout} p-${gap}`}>
        {renderItem(item, index)}
      </div>
    );
  }

  renderCells() {
    let { repeater } = this.props;
    let { rows } = this.state;
    let { gap } = repeater;
    return (
      <tr>
        <td>
          <div className={`row no-gutters c-mx--${gap || 2}`}>
            {rows.map((row, rowIndex) => {
              return this.renderCell(row, rowIndex);
            })}
          </div>
        </td>
      </tr>
    );
  }

  renderTdContent({ row, column, rowIndex, field }) {
    let { component, text, ellipsis, go, href } = column;
    if (component) return component(row, rowIndex);
    let content = text ? text(row, rowIndex) : row[field];
    if (go) return <Link size="xs" inline={true} onClick={(e) => { go(row, rowIndex); e.stopPropagation(); }} >{content}</Link>;
    if (href) return <Link size="xs" inline={true} href={href(row, rowIndex)} >{content}</Link>;
    return ellipsis === false ? content : <p className={`mb-0 c-ellipsis-1`}>{content}</p>;
  }

  renderRows() {
    let { columns, onRowSelect, separator, rowHover, go: rowGo } = this.props;
    let { rows } = this.state;
    let radioName = this.radioName;
    let checkbox = this.checkbox();
    let radio = this.radio();
    let noLine = !Util.empty(separator) && (separator === false || separator.pc === false);
    return (
      rows.map((row, rowIndex) => {
        var key = this.getRowKey(row);
        const isSelected = this.isSelected(key);
        return (
          <TableRow
            hover={rowHover}
            className={`${onRowSelect ? 'c-pointer' : ''}`}
            onClick={event => this.handleRowClick(event, key, row)}   //取消整行选择
            onKeyDown={event => this.handleKeyDown(event, key)}
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={key.value}
            selected={isSelected}
          >
            {
              checkbox ?
                <TableCell padding="checkbox" className={`${noLine ? 'c-lb0' : ''}`}>
                  <Checkbox color="primary" checked={isSelected} onClick={e => this.handleTargetClick(e, key, row)} />
                </TableCell>
                : null
            }
            {
              radio ?
                <TableCell padding="checkbox" className={`${noLine ? 'c-lb0' : ''}`}>
                  <Radio name={radioName} color="primary" checked={isSelected} onClick={e => this.handleTargetClick(e, key, row)} />
                </TableCell>
                : null
            }
            {
              columns.map((column, i) => {
                let field = getColumnField(column);
                let { onClick, className, light, style, width } = column;

                if (!className) {
                  className = light ? "c-text-grey c-text-s1" : "c-text-s1";
                }

                let tdStyle = {};
                if (width) {
                  tdStyle.width = width;
                }
                tdStyle = { ...tdStyle, ...style };

                if (!onClick) {
                  if (rowGo) onClick = rowGo;
                }

                return <TableCell key={i}
                  onClick={onClick ? () => { onClick(row) } : null}
                  align={column.align}
                  style={tdStyle}
                  className={`${noLine ? 'c-lb0' : ''} ${onClick || rowGo ? 'c-pointer' : ''} ${className}`}
                  padding={column.disablePadding ? 'none' : 'default'}>{this.renderTdContent({ row, column, rowIndex, field })}</TableCell>
              })
            }
            {
              rowGo ?
                <TableCell key={"column-go"}
                  onClick={rowGo ? () => { rowGo(row) } : null}
                  align={"center"}
                  width="50px"
                  className={`${noLine ? 'c-lb0' : ''} c-pointer`}
                  padding={'default'}><GoCellLink color="primary" /></TableCell>
                : null
            }
          </TableRow>)
      })
    )
  }

  renderEmpty() {
    let { emptyText, emptyComponent } = this.props;
    return (
      <div className="d-flex h-100">
        {
          emptyComponent ? emptyComponent :
            <Table className="h-100">
              <TableBody className="h-100">
                <TableRow className="h-100">
                  <TableCell style={{ height: "100%", textAlign: "center", border: "none" }}>
                    <h2 className="m-text-muted c-text-s3" style={{ marginBottom: 0, textAlign: "center" }}>{emptyText}</h2>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
        }
      </div>
    )
  }

  renderLoading() {
    return (
      <div className="d-flex h-100">
        <Table className="h-100">
          <TableBody className="h-100">
            <TableRow className="h-100">
              <TableCell style={{ height: "100%", textAlign: "center", border: "none" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <LoadingSlim className="c-mh3" size="sm" message="加载中" />
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    )
  }

  renderHeader() {
    const { order, rows } = this.state;
    let { columns, headers, headerDisablePadding, headerClassName, go } = this.props;
    let radioName = this.radioName;
    if (headers == false) return null;
    return (
      <div className="d-flex flex-column">
        <Table>
          <DataTableHead
            numSelected={rows.filter((row) => this.isSelected(this.getRowKey(row))).length}
            order={order}
            // orderBy={orderBy}
            onSelectAllClick={this.handleSelectAllClick}
            onRequestSort={this.handleRequestSort}
            rowCount={rows.length}
            headers={headers}
            columns={columns}
            headerClassName={headerClassName}
            headerDisablePadding={headerDisablePadding}
            checkbox={this.checkbox()}
            radio={this.radio()}
            radioName={radioName}
            go={go}
          />
        </Table>
      </div>
    )
  }

  renderFooter() {
    const { selected, rows, pageIndex, dataCount, pageCount } = this.state;
    let { page, repeater } = this.props;
    let pageSize = this.getPageSize();
    return (
      <div className={`d-flex flex-column mt-2 ${repeater ? 'c-l shadow-sm bg-white' : ''}`}>
        <Table>
          {
            page ? <TableFooter>
              <TableRow>
                <TablePagination
                  numSelected={selected.length}
                  dataCount={dataCount}
                  pageCount={pageCount}
                  rowsPerPage={pageSize}
                  page={pageIndex}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter> :
              <TableFooter>
                <TableRow>
                  <TablePagination
                    showPage={false}
                    numSelected={selected.length}
                    dataCount={rows.length}
                    pageCount={1}
                    rowsPerPage={rows.length}
                    page={1}
                    onChangePage={() => { }}
                    rowsPerPageOptions={[]}
                    onChangeRowsPerPage={() => { }}
                  />
                </TableRow>
              </TableFooter>
          }
        </Table>
      </div>
    )
  }

  renderMain() {
    let { repeater } = this.props;
    return (
      <div className="d-flex flex-column">
        <Table>
          {/* {headers == false ? null :
              <DataTableHead
                numSelected={rows.filter((row)=> this.isSelected(this.getRowKey(row))).length}
                order={order}
                // orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={rows.length}
                headers={headers}
                columns={columns}
                checkbox={this.checkbox()}
                radio={this.radio()}
                radioName={radioName}
                go={go}
              />
            } */}
          <TableBody>
            {repeater ? this.renderCells() : this.renderRows()}
          </TableBody>
          {/* {
              page ? <TableFooter>
                <TableRow>
                  <TablePagination
                    numSelected={selected.length}
                    dataCount={dataCount}
                    pageCount={pageCount}
                    rowsPerPage={pageSize}
                    page={pageIndex}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter> :
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      showPage={false}
                      numSelected={selected.length}
                      dataCount={rows.length}
                      pageCount={1}
                      rowsPerPage={rows.length}
                      page={1}
                      onChangePage={() => { }}
                      rowsPerPageOptions={[]}
                      onChangeRowsPerPage={() => { }}
                    />
                  </TableRow>
                </TableFooter>
            } */}
        </Table>
      </div>
    )
  }

  getState() {
    return { pageIndex: this.state.pageIndex };
  }

  acceptState(data) {
    this.setState(...data);
  }

  onActivated() {
    super.onActivated();

    if (this.scrollbar && this._scrollbarTop) {
      Scrollbar.load(this.scrollbar, this._scrollbarTop);
    }

  }

  onUnactivated() {
    super.onUnactivated();
  }

  onScrollStop(e) {
    this._scrollbarTop = this.scrollbar.getScrollTop(); //记录位置
  }

  tryScrollable(content) {
    let { scrollable } = this.props;
    return (
      scrollable ? (
        <div className="d-flex c-flex-1">
          <Scrollbar ref={(r) => { this.scrollbar = r; }} onScrollStop={() => { this.onScrollStop(); }}>
            {content}
          </Scrollbar>
        </div>
      ) : content
    );
  }

  renderBody() {
    const { dataCount, rows, loading } = this.state;
    let { page } = this.props;
    let empty = page ? dataCount === 0 : rows.length === 0;
    return (
      <div className="d-flex flex-column c-flex-1">
        {loading || empty ? null : this.renderHeader()}
        {this.tryScrollable(
          loading ? this.renderLoading() :
            (empty ? this.renderEmpty() : this.renderMain())
        )}
        {loading || empty ? null : this.renderFooter()}
      </div>
    );
  }

  renderGroup() {
    let { group } = this.props;
    return (
      <div className="d-flex flex-row h-100">
        <div className="d-flex flex-column h-100">
          <Group ref={(r) => { this.group = r; }} {...group} onChange={() => { this.load(); }} />
        </div>
        <div className="d-flex flex-column c-flex-1 h-100">
          {this.renderBody()}
        </div>
      </div>
    );
  }

  validGroup() {
    let { group } = this.props;
    return group && group.items && group.items.length > 0;
  }

  render() {
    const { selected, dataCount, rows, loading } = this.state;
    let { title, toolbar, page, className, flat, scrollable, group, nowrap } = this.props;
    let empty = page ? dataCount === 0 : rows.length === 0;
    return (
      <Paper elevation={0} className={`c-dataGrid c-datatable ${nowrap ? 'c-datatable-nowrap' : ''} ${flat ? 'c-flat' : ''} d-flex flex-column ${scrollable ? 'h-100' : ''} ${className}`} >
        <div className="d-flex flex-column h-100">
          <div className="d-flex flex-column">
            {title ? <DataTableToolbar title={title} /> : null}
            {toolbar}
          </div>
          {this.validGroup() ? this.renderGroup() : this.renderBody()}
        </div>
      </Paper>
    );
  }
}

DataTable.defaultProps = {
  className: '',
  pageSize: 10,
  emptyText: "暂无数据",
  page: true,
  rowSelect: true,
  rowHover: true,
  headerClassName: ''
}



class Group extends React.Component {   //经过实际使用发现，一旦启用了keepId，该对象就被缓存了，不能通过更改属性来更改SemiT的效果，请使用updateProps()方法
  constructor(props) {
    super(props);
    this.index = props.index || 0;  //由于state会有延迟，所以这里加一个立即生效的属性，防止bug
    this.state = {
      index: this.index
    }
  }

  current() {
    let { items } = this.props;
    if (!items) return null;
    return items[this.index];
  }


  handleClickItem(item, i) {
    this.index = i;
    this.setState({ index: i });
    let { onChange } = this.props;
    if (onChange) onChange(i);
  }


  menuItem(item, i, selected, index) {
    let { icon, text, label } = item;
    return <li key={`menu-${i}`} onClick={() => { this.handleClickItem(item, i); }}>
      <span className={`jr-link d-flex flex-row justify-content-start align-items-center c-py-2 c-px-0 ${selected ? 'active' : ''}`}>
        {createIcon(icon || ArrowRightIcon, "c-icon-s1d5")}
        <p className={`c-flex-1 c-text-s1d5 ${icon ? "pl-2" : ''} c-ellipsis-1 c-mb-0`}>{text || label}</p>
      </span>
    </li>
  }

  renderSection(item, i, index) {
    return (<li key={`menu-section-${i}`} className="module-nav-label c-py-2d5 c-px-0 c-text-s1d5 m-text-dark75">
      {item.section}
    </li>);
  }

  renderItem(item, i, index) {
    let { section } = item;
    if (section) {
      return this.renderSection(item, i, index);
    } else {
      return this.menuItem(item, i, i == index, index);
    }
  }

  menus() {
    let { items } = this.props;
    if (!items) return null;
    let { index } = this.state;
    return <ul key={"items"} className="module-nav c-my-2">
      {items.map((item, i) => this.renderItem(item, i, index))}
    </ul>;
  }

  renderSearch() {
    let { searchable } = this.props;
    if (!searchable) return;
    return (
      <div className="module-side-header c-l0">
        <TextBox className="c-mb-0" label="搜索" width={205} maxlength={100} size="small" variant="outlined" />
      </div>
    );
  }


  sideBar() {
    return (
      <div className={`module-side pr-2`}>
        {this.renderSearch()}
        <div className="module-side-content c-flex-1">
          <Scrollbar>
            {this.menus()}
          </Scrollbar>
        </div>
      </div>)
  };

  renderHeader() {
    let header = this.state.header;
    if (!header) return null;
    return (
      <div className="module-box-header">
        {header}
      </div>
    );
  }

  updateProps(props) {
    this.setState(props);
  }

  render() {
    return (
      <div className={`app-module c-datatable-group c-m-0 h-100 c-lt c-lr`}>
        <div className="app-module-sidenav d-flex c-l0">
          {this.sideBar()}
        </div>
      </div>
    )
  }
}

Group.defaultProps = {

}